<template>
  <div>
    <v-data-table
      mobile-breakpoint="0"
      item-key="id"
      :options.sync="BankAccountTableOptions"
      :server-items-length="totalItems"
      :headers="originHeaders"
      :items-per-page="10"
      :items="bankAccounts"
      :footer-props="footerTable"
      loading-text="Đang Tải"
      :loading="loading"
    >
      <template v-slot:no-data>
        <div class="my-14 font-weight-bold">
          <div>Hiện tại chưa có thông tin trong danh sách.</div>
        </div>
      </template>

      <template v-slot:[`item.name`]="{ item }">
        <CardStudentName :student="item" link />
      </template>

      <template v-slot:[`item.currentClass`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <div v-on="on" style="text-decoration: none; white-space: nowrap">
              <router-link
                v-on="on"
                style="text-decoration: none; white-space: nowrap"
                :to="'/class/' + item.currentClass.id"
                >{{ item.currentClass.title }}
              </router-link>
            </div>
          </template>
          <span>Xem lớp</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.tuitionBank`]="{ item }">
        <div class="my-2">
          <span md="12">{{ get(item.tuitionBank, 'bankCode', '').toUpperCase() }}</span
          ><br />
          <span>{{ item.tuitionBank && item.tuitionBank.accountNumber }}</span
          ><br />
          <span class="text-gray">{{ get(item.tuitionBank, 'accountName', '').toUpperCase() }}</span>
        </div>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn v-if="$auth.policies['update-bank-account']" class="elevation-0" icon @click="editBankAccount(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <DialogEditBankAccount ref="dialog-edit-bank-account" />
  </div>
</template>
<script>
import { get } from 'lodash'
import axios from 'axios'
import { mapActions, mapState } from 'vuex'
import DialogEditBankAccount from '@/modules/tuitionFee/bank-account/DialogEditBankAccount'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'

export default {
  components: {
    DialogEditBankAccount,
    CardStudentName,
  },
  data() {
    return {
      get,
      BankAccountTableOptions: {},
      banks: [],
      originHeaders: [
        {
          text: 'Tên học sinh',
          value: 'name',
          align: 'left',
          sortable: false,
          show: true,
          width: '40%',
        },
        {
          text: 'Lớp',
          value: 'currentClass',
          align: 'left',
          sortable: false,
          show: true,
          width: '25%',
        },
        {
          text: 'Ngân hàng',
          value: 'tuitionBank',
          align: 'left',
          sortable: false,
          show: true,
          width: '25%',
        },
        {
          text: 'Thao tác',
          value: 'action',
          align: 'left',
          sortable: false,
          show: true,
          width: '10%',
        },
      ],
    }
  },
  props: {
    filter: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState({
      bankAccounts: state => state.students.students,
      pageText: state => state.students.pageText,
      loading: state => state.students.loading,
      totalItems: state => state.students.totalItems,
    }),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số học sinh mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
  },
  async created() {
    const banks = await axios.get('https://api.vietqr.io/v2/banks')
    this.banks = banks.data
  },
  methods: {
    ...mapActions({
      requestPageSettings: 'students/requestPageSettings',
    }),
    editBankAccount(student) {
      this.$dialog.confirm({
        title: 'Xác nhận chỉnh sửa?',
        text: '<div>Thay đổi thông tin tài khoản ngân hàng có thể ảnh hưởng đến các giao dịch trong tương lai. Bạn muốn tiếp tục chỉnh sửa?</div>',
        okText: 'XÁC NHẬN',
        cancelText: 'Hủy',
        done: async () => {
          this.$refs['dialog-edit-bank-account'].openDialog(student, this.banks)
        },
      })
    },
  },
  filters: {
    getCurrentClass(currentClass) {
      return currentClass == null ? '' : currentClass.title
    },
  },
  watch: {
    BankAccountTableOptions: {
      async handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          await this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
          })
        }
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.text-gray {
  color: #797979;
}
</style>
